import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Chat } from '../../model/v2/chat/chat';
import { ChatDict } from '../../model/v2/chat/chat-dict';
import { ChatForUser } from '../../model/v2/chat/chat-for-user';
import { SaveChat, SendChatCommunication } from '../../model/v2/chat/save-chat';
import { BaseService } from '../shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private baseService: BaseService) { }

  getChat(toUserId: number, fromUserId: number): Observable<Chat> {
    return this.baseService.get<Chat>(`Chat/GetChat/ToUser/${toUserId}/FromUser/${fromUserId}`);
  }

  getMessagesPerUser(forUserId: number): Observable<ChatDict[]> {
    return this.baseService.get<ChatDict[]>(`Chat/GetMessagesPerUser/${forUserId}`);
  }

  getChatForUser(forUserId: number): Observable<ChatForUser[]> {
    return this.baseService.get<ChatForUser[]>(`Chat/GetChatForUser/${forUserId}`);
  }

  getReceivedChat(toUserId: number): Observable<ChatForUser[]> {
    return this.baseService.get<ChatForUser[]>(`Chat/GetReceivedChat/${toUserId}`);
  }

  saveChat(chat: SaveChat): Observable<Chat> {
    return this.baseService.post<Chat>(`Chat/SaveChat`, chat);
  }

  markAsRead(messageId: number): Observable<any> {
    return this.baseService.post<any>(`Chat/ReadMessage`, messageId);
  }

  sendCommunication(communication: SendChatCommunication): Observable<any> {
    return this.baseService.post<any>(`Chat/SendCommunication`, communication);
  }
  sendCommunicationGlobal(communication: SendChatCommunication): Observable<any> {
    return this.baseService.post<any>(`Chat/SendCommunicationGlobal`, communication);
  }
}
